/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import './DependentsTile.css';
import { Button, Grid, Typography } from '@mui/material';
import CardContentTile from '../CardContentTile/CardContentTile';
import CardForOnclick from '../CardForOnclick';

import UpdateDepPrPicController from '../UpdateDependentProfilePic/UpdateDepPrPicController';

const DependentsTile = (props: any) => {
  return (
    <Grid container className="tile-containerDependent">
      <Grid
        item
        xs={12}
        style={{
          alignItems: 'center',
          justifyContent: 'center',
          display: 'flex',
          marginTop: '1em',
        }}
      >
        <UpdateDepPrPicController
          profilePic={props.profilePic}
          Dep_id={props.Dep_id}
          isAttachmentSigned={true}
        />
      </Grid>
      <Grid
        item
        xs={12}
        style={{
          alignItems: 'center',
          justifyContent: 'center',
          display: 'flex',
          marginTop: '0.5em',
        }}
      >
        <Typography
          style={{
            fontFamily: 'Lato',
            fontSize: '1em',
            fontWeight: 'bold',
            color: '#000000',
          }}
        >
          {props.title1}
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        style={{
          alignItems: 'center',
          justifyContent: 'center',
          display: 'flex',
          marginTop: '0.5em',
        }}
      >
        <Button
          style={{
            backgroundColor: '#7C0E6F14',
            height: '2em',
            width: '3em',
            fontFamily: 'Lato',
            fontSize: '0.75em',
            fontWeight: 'bold',
            color: '#7C0E6F',
            textTransform: 'capitalize',
          }}
        >
          {props.relation}
        </Button>
      </Grid>

      <Grid item xs={12} style={{ marginTop: '0.8em', marginBottom: '0.8em' }}>
        <CardContentTile
          tile_key={props.tile_key1}
          tile_value={props.tile_value1}
          is_bold={true}
        />
        <CardContentTile
          tile_key={props.tile_key2}
          tile_value={props.tile_value2}
          is_bold={true}
        />
        <CardContentTile
          tile_key={props.tile_key3}
          tile_value={props.tile_value3}
          is_bold={true}
        />
        <CardContentTile
          tile_key={props.tile_key4}
          tile_value={props.tile_value4}
          is_bold={true}
        />
        <CardForOnclick
          tile_key={props.tile_key5}
          is_bold={true}
          onClick={props.onClick1}
        />
        <CardForOnclick
          tile_key={props.tile_key6}
          is_bold={true}
          onClick={props.onClick2}
        />
      </Grid>
    </Grid>
  );
};
export default DependentsTile;
